var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { Column, GridContainer, Row } from '@vp/swan';
import ErrorIcon from './ErrorIcon';
import ErrorMessagingCTA from './ErrorMessagingCTA';
import { ErrorDetailsPanel } from './ErrorDetailsPanel';
/* Your starter React component */
export const DesignExperienceErrorUi = (props) => {
    const { Icon, handleErrorLogoClick, errorHeader, errorSubHeader, primaryButtonMessage, primaryOnClick, secondaryButtonMessage, secondaryOnClick, errorDetailChildren } = props, rest = __rest(props, ["Icon", "handleErrorLogoClick", "errorHeader", "errorSubHeader", "primaryButtonMessage", "primaryOnClick", "secondaryButtonMessage", "secondaryOnClick", "errorDetailChildren"]);
    const [showDetails, setShowDetails] = useState(false);
    const handleLogoClick = () => {
        handleErrorLogoClick && handleErrorLogoClick();
        setShowDetails(!showDetails);
    };
    return (React.createElement(GridContainer, Object.assign({}, rest),
        React.createElement(Row, null,
            React.createElement(Column, { span: 5, spanXs: 12, spanSm: 12, pushMd: 7, pushLg: 7, pushXl: 7 },
                React.createElement(ErrorIcon, { Icon: Icon, handleErrorLogoClick: handleLogoClick })),
            React.createElement(Column, { span: 6, spanXs: 12, spanSm: 12, pullMd: 4, pullLg: 4, pullXl: 4 },
                React.createElement(ErrorMessagingCTA, { errorHeader: errorHeader, errorSubHeader: errorSubHeader, primaryButtonMessage: primaryButtonMessage, primaryOnClick: primaryOnClick, secondaryButtonMessage: secondaryButtonMessage, secondaryOnClick: secondaryOnClick }))),
        React.createElement(Row, null, showDetails && React.createElement(ErrorDetailsPanel, null, errorDetailChildren))));
};
//# sourceMappingURL=DesignExperienceErrorUi.js.map